import { useMemo } from 'react';
import { EMPTY_OBJ, RequestDeviceCodeDefaultProps } from "../Constants.js";
import useObjectKeysMemoize from "./useObjectKeysMemoize.js";
export default function useRequestDeviceCode(opts) {
  const {
    classNames = EMPTY_OBJ,
    variants: pVariants,
    options: pOptions,
    ...restProps
  } = opts;
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...RequestDeviceCodeDefaultProps.variants,
      ...v
    };
  }, [v]);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...RequestDeviceCodeDefaultProps.options,
      ...o
    };
  }, [o]);
  const rest = useObjectKeysMemoize(restProps);
  return useMemo(() => {
    return {
      variants,
      classNames,
      options,
      ...rest
    };
  }, [variants, classNames, options, rest]);
}